@if (owner$ | async; as optionsPhysical) {
  <div class="">
    <div class="row w-1200 p-1">
      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 w-1200"
        style="position: relative"
      >
        <a class="btn-toggle-info" (click)="toggle = true">
          @if (pictureFile) {
            <div
              class="advisor-picture"
              [ngStyle]="{
                'background-image': 'url(' + pictureFile + ')',
              }"
            >
              <i class="fa fa-bars face"></i>
            </div>
          }
          @if (!pictureFile) {
            <span>
              <i class="fa fa-bars face"></i>
              <i class="fa fa-user-circle text-gray avatar pictureFileIcon"></i>
            </span>
          }
        </a>
        @if (loading) {
          <pr-loader
            text="Merci de patienter pendant que nous préparons votre opération"
          ></pr-loader>
        }
        <div class="subscription">
          <div class="container">
            <!-- Séquençage V2 — Écran de choix du périmètre, intercalé avant le /init -->
            @if (showScopeStep) {
              <subscription-scope-choice
                data-testid="dashboard-souscription-init-scope"
                [showPrevious]="showScopePrevious"
                [fullScopeAllowed]="fullScopeAllowed"
                (scopeSelected)="onScopeSelected($event)"
                (prevClicked)="onScopePrev()"
              ></subscription-scope-choice>
            }
            <ng-container *ngIf="!showScopeStep">
              <!-- Choix devis ou produit (CONTINGENCY uniquement) -->
              @if (showDevisOrProductChoice) {
                <question-description
                  titleDir="left"
                  subTitleDir="left"
                  title="Comment souhaitez-vous souscrire ?"
                  subTitle=""
                >
                </question-description>
                <div class="row d-flex">
                  <div class="col-xs-12 col-sm-12 col-md-12">
                    <div class="btn-group">
                      <pr-button
                        data-testid="dashboard-souscription-init-from-devis"
                        size="lg"
                        type="button"
                        display="neutral"
                        label="Partir d'un devis existant"
                        (onClick)="onSelectFromDevis()"
                      ></pr-button>
                      <pr-button
                        data-testid="dashboard-souscription-init-from-product"
                        size="lg"
                        type="button"
                        label="Choisir un produit"
                        (onClick)="onSelectFromProduct()"
                      ></pr-button>
                    </div>
                  </div>
                </div>
              }
              <!-- Liste des devis (apres choix "devis") -->
              @if (showDevisList) {
                <question-description
                  titleDir="left"
                  subTitleDir="left"
                  title="Selectionnez un devis"
                  subTitle=""
                >
                </question-description>
                @for (devis of devisList; track devis.id) {
                  <div
                    data-testid="dashboard-souscription-init-devis-card"
                    class="devis-card"
                    style="cursor: pointer; padding: 1rem; margin-bottom: 0.5rem; border: 1px solid #ddd; border-radius: 8px;"
                    (click)="onDevisSelected(devis)"
                  >
                    <strong>{{ devis.productName }}</strong> —
                    {{ devis.assureurName }}
                    <br />{{ devis.cotisation }}€/{{
                      devis.cotisationPeriode === 'MENSUEL' ? 'mois' : 'an'
                    }}
                    — {{ devis.titulaireName }}
                  </div>
                }
                <div class="btn-group">
                  <pr-button
                    data-testid="dashboard-souscription-init-devis-back"
                    size="lg"
                    type="button"
                    label="Retour"
                    icon="arrow_left"
                    (onClick)="
                      showDevisList = false;
                      showDevisOrProductChoice = true
                    "
                  ></pr-button>
                </div>
              }
              <!-- Selection du produit -->
              @if (showProductSelection) {
                <product-init
                  data-testid="dashboard-souscription-init-product"
                  (productEvent)="saveProduct($event)"
                ></product-init>
              }
              <!-- Selection du/des consultants -->
              @if (showQuestionSeller) {
                <question-description
                  titleDir="left"
                  subTitleDir="left"
                  title="Qui effectue la vente ?"
                  subTitle=""
                >
                </question-description>
                <div class="sellers" data-testid="dashboard-souscription-init-sellers">
                  <ng-container
                    *ngTemplateOutlet="
                      sellerCard;
                      context: {
                        $implicit: attachedConsultant,
                        role: secondConsultant && !delBin ? 'Consultant principal' : 'Consultant',
                      }
                    "
                  ></ng-container>
                  @if (secondConsultant && !delBin) {
                    <ng-container
                      *ngTemplateOutlet="sellerCard; context: { $implicit: secondConsultant, role: 'Consultant en binôme' }"
                    ></ng-container>
                  }
                  @if (showAttachedLegalEntitySelect) {
                    <div class="seller-card">
                      <div class="seller-identity">
                        <span class="seller-role">Rattachement de la souscription</span>
                        <span class="seller-name">{{ attachedLegalEntityOwner }}</span>
                      </div>
                      <pr-input-column class="seller-entity" label="Entité légale de rattachement">
                        <mat-select
                          [value]="legalEntitySelection?.attachedLegalEntityId"
                          (selectionChange)="onAttachedLegalEntityChange($event)"
                        >
                          @for (option of attachedLegalEntitySelectOptions; track option.value) {
                            <mat-option [value]="option.value">{{ option.label }}</mat-option>
                          }
                        </mat-select>
                      </pr-input-column>
                    </div>
                  }
                  @if (secondConsultant && !delBin) {
                    <div class="sellers-actions">
                      <pr-button
                        size="lg"
                        type="button"
                        display="neutral"
                        label="Retirer le binôme"
                        (onClick)="deleteBinome()"
                      ></pr-button>
                    </div>
                  } @else {
                    <p class="sellers-note">Aucun binôme pour ce client</p>
                  }
                </div>
                <ng-template #sellerCard let-memberId let-role="role">
                  <div class="seller-card">
                    <div class="seller-identity">
                      <span class="seller-role">{{ role }}</span>
                      <span class="seller-name">{{ getConsultantFullName(memberId) }}</span>
                    </div>
                    @if (showSellerLegalEntitySelect(memberId)) {
                      <pr-input-column class="seller-entity" label="Entité légale">
                        <mat-select
                          [value]="legalEntitySelection?.sellerLegalEntities[memberId]"
                          (selectionChange)="onSellerLegalEntityChange(memberId, $event)"
                        >
                          @for (option of sellerLegalEntitySelectOptions[memberId]; track option.value) {
                            <mat-option [value]="option.value">{{ option.label }}</mat-option>
                          }
                        </mat-select>
                      </pr-input-column>
                    }
                  </div>
                </ng-template>
              }
              <!-- Selection souscription individuelle ou co-souscription -->
              @if (showQuestionDescription) {
                <question-description
                  titleDir="left"
                  subTitleDir="left"
                  title="Pour qui souscrivez-vous ?"
                  subTitle=""
                >
                </question-description>
                <subscription-options
                  data-testid="dashboard-souscription-init-options"
                  [productType]="productType"
                  [subsciptionOptions]="subsciptionOptions"
                  [sessionConsultant]="sessionConsultant"
                  (selectOptionEvent)="selectOption($event)"
                  [maxSelected]="maxSelected"
                ></subscription-options>
                <div class="row d-flex">
                  <div class="col-xs-12 col-sm-12 col-md-12">
                    <div class="btn-group">
                      <pr-button
                        data-testid="dashboard-souscription-init-options-prev"
                        size="lg"
                        type="button"
                        label="Question précédente"
                        icon="arrow_left"
                        (onClick)="prev()"
                      ></pr-button>
                      <pr-button
                        data-testid="dashboard-souscription-init-options-submit"
                        size="lg"
                        type="submit"
                        display="neutral"
                        label="Je détermine mon profil."
                        (onClick)="onSubmitSelected()"
                      ></pr-button>
                    </div>
                  </div>
                </div>
              }
              <!-- Selection du/des souscripteur(s) -->
              <owner-selection
                data-testid="dashboard-souscription-init-owners"
                [form]="form"
                [ownerOptionsPhysical]="ownerOptionsPhysical"
                [ownerCompanyOptions]="ownerCompanyOptions"
                [selectedSubmit]="selectedSubmit"
                [maxSelected]="maxSelected"
                (onSubmitEvent)="onSubmit()"
                (onPrevEvent)="prev()"
              ></owner-selection>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
}
